import React, { Component, Fragment, useContext } from "react";
import { connect } from "react-redux";
import { ShepherdTour, ShepherdTourContext } from "react-shepherd";
import { Link, withRouter } from "react-router-dom";

import userImage from "../../../assets/images/svg/userprofile.svg";
import okaygoIcon from "../../../assets/images/svg/okaygoIcon.svg";
import SearchBar from "./searchBar";
import Hamburger from "../../UI/Hamburger/Hamburger";
import { isMobile } from "../../../containers/utils";
import "./Toolbar.css";

const SHEPHERD_TOUR_ROUTES = ["/dashboard"];

const StartTour = ({ showStartBtn, autoStart, setNoAutoStart }) => {
  const TOUR = useContext(ShepherdTourContext);

  if (autoStart) {
    TOUR.start();
    setNoAutoStart();
  }
  return showStartBtn ? (
    <span
      role="presentation"
      onClick={TOUR.start}
      className="start-tour-btn icon-question"
    />
  ) : null;
};

class Toolbar extends Component {
  state = {
    autoStartState: false,
  };

  componentDidMount() {
    this.setState({
      autoStartState: this.props.shepherdTourData.autoStart,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shepherdTourData.autoStart
      !== prevProps.shepherdTourData.autoStart
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        autoStartState: this.props.shepherdTourData.autoStart,
      });
    }
  }

  setNoAutoStart = () => {
    this.setState({
      autoStartState: false,
    });
  };

  render() {
    let {
      location,
      notificationSupport,
      showEntitySearchBar,
      shepherdTourData,
      showTourButton,
      ...props
    } = this.props;
    let searchRoutes = ["/process", "/tasks", "/bgv"];
    const handleGoBack = () => {
      window.location.href = "https://www.eflex.okaygo.in/";
    };

    let showSearchBar = false;
    if (searchRoutes.includes(location.pathname)) {
      showSearchBar = true;
    }

    if (location.pathname.startsWith("/entity") && !showEntitySearchBar) {
      showSearchBar = false;
    }

    let createOrglogo = null;
    let oranameVar = null;
    let characterZero = null;
    if (props.orgName) {
      oranameVar = props.orgName;
      characterZero = oranameVar.charAt(0);
    }

    if (!props.orgLogo) {
      let brandOrgName = props.orgName && props.orgName.length > 16
          ? "brand_logo with-no-image brandOrgText"
          : "brand_logo with-no-image brandOrgTextinitial";
      createOrglogo = (
        <>
          <span className={brandOrgName}>
            {/* <a href="javascript:void(0)"> */}
            <div className="nologo-text-wrapper">
              <span className="noLogo-class">{characterZero}</span>
              <span className="noLogo-orgName">{props.orgName}</span>
            </div>
            {/* </a> */}
          </span>
        </>
      );
    } else if (props.orgLogo && !props.showOrgName) {
      createOrglogo = (
        <>
          <span className="brand_logo">
            {/* <a href="javascript:void(0)"> */}
            <img src={props.orgLogo} alt="" />
            {/* </a> */}
          </span>
        </>
      );
    } else if (props.orgLogo && props.showOrgName) {
      createOrglogo = (
        <>
          <span className="brand_logo text-change brand_logo_cont">
            {/* <a href="javascript:void(0)"> */}
            <img src={props.orgLogo} alt="" />
            <span className="brand_logo_and_text">{props.orgName}</span>
            {/* </a> */}
          </span>
        </>
      );
    }

    const shouldRenderOkaygoIcon = location.pathname.includes("process_okaygo")
      || location.pathname.includes("worker_view");

    const showGoBackButton = !location.pathname.includes("tasks");

    const showImpDash = localStorage.getItem("userRole") !== "qc-admin";
    const workerView = !props.history.location.pathname.includes("worker_view");

    let navbarStyle = {};
    if (props.hamburger) {
      if (isMobile()) {
        navbarStyle = { width: window.innerWidth * 0.75, background: "white" };
      }
    }

    return (
      <Fragment>
        <div className="Header_container">
          <nav
            className={
              props.hamburger
                ? "navbar navbar-fixed-top navbar_expand_fixed_top active"
                : "navbar navbar-fixed-top navbar_expand_fixed_top"
            }
          >
            {workerView && (
              <div className="navbar-brand navbar_brand_p" style={navbarStyle}>
                {createOrglogo}
                <span className="menue_icon">
                  <Hamburger
                    isOpen={props.hamburger}
                    clickFunc={props.clicked}
                  />
                </span>
              </div>
            )}
            {shouldRenderOkaygoIcon && (
              <img
                src={okaygoIcon}
                alt=""
                style={{ position: "absolute", left: "60px", width: "73px" }}
              />
            )}
            <div
              className="collapse navbar-collapse navbar_collapse_cont"
              id="navbarCollapse"
            >
              <SearchBar
                showSearchBar={showSearchBar}
                pathName={this.props.location.pathname}
                {...props}
              />
              <ShepherdTour
                steps={shepherdTourData.steps || []}
                tourOptions={shepherdTourData.tourOptions || {}}
              >
                <StartTour
                  setNoAutoStart={this.setNoAutoStart}
                  autoStart={this.state.autoStartState}
                  showStartBtn={
                    SHEPHERD_TOUR_ROUTES.includes(location.pathname)
                      ? showTourButton
                      : false
                  }
                />
              </ShepherdTour>
              {/* {websocketAndNotification} */}
              <div className="user_profile_drop_cont">
                {!showImpDash && (
                  <ul className="navbar-nav">
                    <li className="dropdown profile_cont">
                      <a
                        href="./"
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span>
                          <img
                            className="userAvatar"
                            src={props.profile ? props.profile : userImage}
                            alt=""
                          />
                        </span>
                        <span
                          className="user_profile_name"
                          style={{ color: "white" }}
                        >
                          {`${props.firstName} ${props.lastName}`}
                        </span>
                        <span className="caret" style={{ color: "white" }} />
                      </a>
                      <ul className="dropdown-menu">
                        {/* <li><Link to="/profile">My Profile</Link></li> */}
                        {props.uiPermission && (
                          <li>
                            <Link to="/manage-account">Manage Account</Link>
                          </li>
                        )}
                        <li role="separator" className="divider" />
                        <li>
                          <Link to="/logout">
                            <span>Logout</span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                )}
                {showImpDash
                  && workerView
                  && localStorage.getItem("userRole") !== "mettl-invigilation"
                  && localStorage.getItem("userRole") !== "OG Vendor" && (
                    <a href="/org/process/import-history" target="_blank">
                      <button type="button" className="goBackBtn importBtn">
                        Import History
                      </button>
                    </a>
                  )}
                {showImpDash
                  && showGoBackButton
                  && localStorage.getItem("userRole") !== "mettl-invigilation"
                  && localStorage.getItem("userRole") !== "OG Vendor" && (
                    <button
                      type="button"
                      className="goBackBtn"
                      onClick={handleGoBack}
                    >
                      Admin dashboard
                    </button>
                  )}
              </div>
            </div>
          </nav>
        </div>
      </Fragment>
    );
  }
}

const mapsStateToProps = (state) => ({
  orgLogo: state.orgLogo.logo,
  orgName: state.orgLogo.name,
  showOrgName: state.orgLogo.showOrgName,
  firstName: state.auth.firstName,
  lastName: state.auth.lastName,
  uiPermission: state.auth.uiPermissions.organisation.view,
  notificationSupport: state.auth.notificationSupport,
  profile: state.auth.profilePhoto,
  showEntitySearchBar: state.entity.showSearchBar,
});

export default withRouter(connect(mapsStateToProps)(Toolbar));
